import { AppointmentActivityList } from ".";

export function ExposableAptActivity({
  attributes,
  elementRef,
}: {
  attributes: Record<string, string>;
  elementRef: HTMLElement;
}) {
  const { aid } = attributes;
  return (
    <div className="dr-h-full dr-w-full dr-overflow-y-auto">
      <AppointmentActivityList aid={aid} />
    </div>
  );
}
